import {useCallback, useState} from 'react'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

type BannerType = 'trustpilot' | 'trustSurvey'

export const useSearchResultsBanner = () => {
  const {search} = useBrandCapabilities()
  const {hasTrustBanners} = search
  const toggle = useToggle()
  const isSurveyBannerEnabled =
    hasTrustBanners && toggle('feature-survey-banner', false, true)
  const [canRenderTrustSurvey, setCanRenderTrustSurvey] =
    useState(hasTrustBanners)

  const isBannerEnabled = useCallback(
    (type: BannerType, index: number) => {
      switch (type) {
        case 'trustpilot':
          return hasTrustBanners && index === 1
        case 'trustSurvey':
          return (
            hasTrustBanners &&
            isSurveyBannerEnabled &&
            canRenderTrustSurvey &&
            index === 1
          )
        default:
          return false
      }
    },
    [canRenderTrustSurvey, hasTrustBanners, isSurveyBannerEnabled]
  )

  return {
    isBannerEnabled,
    onTrustSurveyVisibilityChange: setCanRenderTrustSurvey
  }
}
